<template>
    <div v-if="show">
      <section class="section">
        <div class="container">
          <div class="columns is-variable is-6">
            <div class="column is-two-fifths">
              <content-placeholders>
                <content-placeholders-img  style="height:355px" />
              </content-placeholders>
            </div>
            <div class="column is-half">
              <content-placeholders>
                <content-placeholders-heading :img="false" />
                <content-placeholders-heading :img="false" />
              </content-placeholders>
            </div>
          </div>
        </div>
      </section>
      <section class="section has-background-white">
        <div class="container">
          <div class="columns">
            <div class="column is-8 is-offset-2">
              <content-placeholders>
                <content-placeholders-heading :img="false" />
                <content-placeholders-heading :img="false" />
                <content-placeholders-text :lines="5" />
              </content-placeholders>
            </div>
          </div>
        </div>
      </section>
    </div>
</template>

<script>
export default {
  name: "LoadingPlaceholder",
  props: {
    show: Boolean
  }
};
</script>

<style scoped lang="scss">

</style>
